import * as React from "react"
import { connect } from "react-redux";
import { change, FieldArray, getFormSubmitErrors, InjectedFormProps, reduxForm } from "redux-form";
import {
  IssueType,
  isClaim,
  isComplaint,
  UserRoles,
  isOneOf,
  CaseType,
  CaseFormType,
} from "src/constants/api";
import { FORM_ERROR_MESSAGE, FORM_TYPE_MAIN } from "src/constants/data";
import { getStringAfterSubstring, getStringBeforeSubstring } from "src/utils";
import { ConditionalField, DateField, dateToTimestamp, DisableForRoles, EnableForRoles, FlexGridItem, FlexNumberField, FlexTextField, FlexTextFieldNumber, HideForRoles, maxLength50, required, TextArea, timestampToDate, validDate, validEmail, validPhoneNo, validYear } from "./form_utility";
import AsyncSelect from "react-select/async";
import FormSelect from "../common/form/controls/select";
import FormSelectAutoComplete from "../common/form/controls/select-autocomplete";
import { apiGetSPUserViaGraph } from "src/effects/api/home";
import { stylesReactSelect } from "src/styles/form";
import {
  caseTypeData,
  complaintStatusData,
  OnHoldStatusData,
  inCaseOfShipmentData,
  issueTypeData,
  inCaseOfShipmentDataForIncident,
} from "../../constants/dropdown";
import { Checkbox, FormLabel, Grid } from "@material-ui/core";
import UnicefOrderNoForm from "./unicef-orderNo-form";
import SupplyInfoForm from "./supply-info-form";
import AttachmentContainer from "src/components/common/attachment-container";
import { IDetailState } from "src/reducers/detail";
import { actionDeleteAttachment, actionDownloadAttachment, actionSaveAttachmentData } from "src/actions/detail";
import { openToaster, closeToaster } from "src/actions/common";
import mainform from "./mainform";

const CURRENCY_LIST: any = (window as any).currencyList;
const categoryList: any = (window as any).categories;

interface IIncidentReportProps {
  countries: IDetailState["countries"];
  issueTypes: IDetailState["issueTypes"];
  claimStatus: IDetailState["claimStatus"];
  claimTypes: IDetailState["claimTypes"];
  routeParams: any;
  saveAttachmentData: typeof actionSaveAttachmentData;
  downloadAttachment: typeof actionDownloadAttachment;
  deleteAttachment: typeof actionDeleteAttachment;
  attachmentData: IDetailState["attachmentData"];
  uniqueId: any;
  mainForm: any;
  caseData: any;
  allowEdit: boolean;
  currentRoleId: number;
  isNewCase: boolean;
  dispatch: any;
  isLockForEdit: any;
  countriesData: any;
  currentUser: any;
  currentUsername: any;
  openToaster: typeof openToaster;
  submitFailed: any;
  invalid: any;
  isToasterVisible: any;
  closeToaster: typeof closeToaster;
}

type IncidentReportProps = IIncidentReportProps & InjectedFormProps;

class MainFormIncidentReportComponent extends React.Component<IncidentReportProps, any> {
  constructor(props: IncidentReportProps) {
    super(props);
    this.state = {
      filteredIssueTypes: [],
      filteredInCaseShipment: [],
      isFirstLoadInEditMode: false
    };
  }

  public componentDidMount() {
    // const { reset } = this.props;
    // reset();
    this.setState({ isFirstLoadInEditMode: false });
  }

  public componentDidUpdate(prevProps: any) {
    this.FilterIssueTypes();
    this.setDefaultValues();
  }

  public componentWillUnmount() {
    const { reset, closeToaster } = this.props;
    //reset();
    closeToaster();
  }

  private FilterIssueTypes = () => {
    const { issueTypes } = this.props;
    if (issueTypes && this.state.filteredIssueTypes.length === 0) {
      let filteredIssueTypes: any = [];
      issueTypes.forEach((item: any) => {
        if (issueTypeData.includes(item.name)) {
          filteredIssueTypes.push(item);
        }
      });

      this.setState({ filteredIssueTypes });
    }
  }

  private setDefaultValues = () => {
    const { dispatch, mainForm } = this.props;
    if (mainForm && mainForm.mainForm.values && !mainForm.mainForm.values.caseType) {
      dispatch(change("mainForm", "caseType", CaseType.ComplaintClaim));
      dispatch(change("mainForm", "category", "21"));
      dispatch(change("mainForm", "caseFormType", CaseFormType.Incident));
    }
  }

  private setSupplyInfoValues = () => {
    const { dispatch, mainForm, isNewCase } = this.props;
    const { isFirstLoadInEditMode } = this.state;

    if (!isNewCase && mainForm && mainForm.mainForm.values && !isFirstLoadInEditMode) {
      let supplyInfo: any = [];
      if (mainForm.mainForm.values.supplyInfo && mainForm.mainForm.values.supplyInfo.length) {
        supplyInfo = mainForm.mainForm.values.supplyInfo;
        supplyInfo.map((item: any, index: any) => {
          item.isTempExcusrsion =
            (item.isTempExcusrsion !== null || item.isTempExcusrsion !== undefined) ?
              item.isTempExcusrsion.toString() : item.isTempExcusrsion;

          item.isDataMonitoringDeviceInstalled =
            (item.isDataMonitoringDeviceInstalled !== null || item.isDataMonitoringDeviceInstalled !== undefined) ?
              item.isDataMonitoringDeviceInstalled.toString() : item.isDataMonitoringDeviceInstalled;
        });
        dispatch(change("mainForm", "supplyInfos", supplyInfo));
      }

      if (mainForm.mainForm.values.unicefOrders) {
        const unicefOrders = JSON.parse(mainForm.mainForm.values.unicefOrders);

        if (unicefOrders && unicefOrders.length) {
          dispatch(change("mainForm", "unicefOrderNos", unicefOrders));
        }

        this.setState({ isFirstLoadInEditMode: true });
      }
    }
  }

  // handle input change event
  private handleInputChange = (value: any) => {
    this.setState({
      inputValue: value,
    });
  };

  private handleChangeCaseType = (event: any) => {
    const caseTypeValue = event.target.value;
    const { dispatch } = this.props;
    if (caseTypeValue === CaseType.Claim) {
      // Reset Complaint Status field
      dispatch(change("mainForm", "complaintStatus", null));
      dispatch(change("mainForm", "onHold", null));
    } else if (caseTypeValue === CaseType.Complaint) {
      // Reset Claim Status, Claim Type and Insurance policy year field
      dispatch(change("mainForm", "claimStatus", null));
      dispatch(change("mainForm", "claimType", null));
      dispatch(change("mainForm", "insurancePolicyYear", null));
      dispatch(change("mainForm", "complaintStatus", true));
      dispatch(change("mainForm", "onHold", false));
    }
  };

  private handleChangeIssueType = (event: any) => {
    const { dispatch } = this.props;
    dispatch(change("mainForm", "transportMethod", ""));
    dispatch(change("mainForm", "nameOfCarrier", ""));
    dispatch(change("mainForm", "departureDate", null));
    dispatch(change("mainForm", "expectedArrivalDate", null));
    dispatch(change("mainForm", "TransportUsdvalue", ""));

    dispatch(change("mainForm", "productName", ""));
    dispatch(change("mainForm", "manufacturer", ""));
    dispatch(change("mainForm", "expiryDate", null));
    dispatch(change("mainForm", "dateReceived", null));
    dispatch(change("mainForm", "ProductUsdvalue", ""));

    dispatch(change("mainForm", "inCaseOfShipment", null));
  };

  private changeCountriesAffected = (event: any, values: any) => {
    const { dispatch } = this.props;
    if (values && values.length) {
      const unique = values
        .map((item: any) => item.unicefregion)
        .filter(
          (value: any, index: any, self: any) => self.indexOf(value) === index
        )
        .toString();
      if (unique) {
        dispatch(change("mainForm", "regions", unique));
      } else {
        dispatch(change("mainForm", "regions", "UNKOWN"));
      }
    } else {
      dispatch(change("mainForm", "regions", ""));
    }
  };

  public render() {
    const {
      handleSubmit,
      //  countries,
      issueTypes,
      claimStatus,
      claimTypes,
      saveAttachmentData,
      deleteAttachment,
      downloadAttachment,
      attachmentData,
      uniqueId,
      isNewCase,
      mainForm,
      countriesData,
      submitFailed,
      invalid,
      openToaster,
      isToasterVisible,
      closeToaster,
      dispatch,
    } = this.props;

    const disableForm = this.disableForm();

    const formValues = mainForm.mainForm ? mainForm.mainForm.values : null;

    if (submitFailed && invalid) {
      openToaster(FORM_ERROR_MESSAGE, false);
    } else if (!invalid && isToasterVisible) {
      closeToaster();
    }
    return (
      <form onSubmit={handleSubmit}>
        <Grid style={{ paddingTop: "25px" }} container={true} spacing={2}>
          <FlexGridItem xs={6}>
            <FlexTextField disabled={true} name="createdBy" label="Submitter" />
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <DateField
              name="created"
              label="Case created"
              format={timestampToDate}
              normalize={dateToTimestamp}
              disabled={true}
            />
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <FlexTextField
              name="contactPerson"
              label="Contact Person"
              required={true}
              disabled={disableForm}
              validate={[required, maxLength50]}
            />
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <FlexTextField disabled={true} name="caseNo" label="Case No" />
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <FlexTextField
              name="phone"
              label="Phone"
              required={true}
              validate={[required, validPhoneNo, maxLength50]}
              disabled={disableForm}
            />
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <HideForRoles roles={[UserRoles.Partner, UserRoles.FMC, UserRoles.UNICEF,]}>
              <DisableForRoles
                roles={[
                  UserRoles.UNICEF,
                  UserRoles.QMU,
                  UserRoles.INS,
                  UserRoles.Solution_Owner,
                  UserRoles.Solution_Team,
                ]}
                disableField={disableForm}
              >
                <FormSelect
                  label="Case Type"
                  name="caseType"
                  data={caseTypeData}
                  onChange={this.handleChangeCaseType}
                />
              </DisableForRoles>
            </HideForRoles>
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <FlexTextField
              name="email"
              label="Email"
              required={true}
              validate={[required, validEmail, maxLength50]}
              disabled={disableForm}
            />
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <HideForRoles roles={[UserRoles.Partner, UserRoles.FMC]}>
              <DisableForRoles
                roles={[
                  UserRoles.UNICEF,
                  UserRoles.INS,
                  UserRoles.Solution_Owner,
                  UserRoles.Solution_Team,
                ]}
                isnewcase={isNewCase}
                disableField={disableForm}
              >
                {/* <ConditionalField
                  formName="mainForm"
                  field="caseType"
                  condition={isComplaint}
                > */}
                <FormSelect
                  name="complaintStatus"
                  label="Incident Status"
                  data={complaintStatusData}
                />
                {/* </ConditionalField> */}
              </DisableForRoles>
            </HideForRoles>
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <FormSelectAutoComplete
              name="countriesAffected"
              label="Select Countries affected"
              data={countriesData}
              isMulti={true}
              disabled={disableForm}
              required={true}
              validate={required}
              onChange={this.changeCountriesAffected}
            />
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <HideForRoles roles={[UserRoles.Partner, UserRoles.FMC, UserRoles.UNICEF]}>
              <DisableForRoles
                roles={[
                  UserRoles.UNICEF,
                  UserRoles.INS,
                  UserRoles.Solution_Owner,
                  UserRoles.Solution_Team,
                ]}
                isnewcase={isNewCase}
                disableField={disableForm}
              >
                {/* <ConditionalField
                  formName="mainForm"
                  field="caseType"
                  condition={isComplaint}
                > */}
                <FormSelect
                  name="onHold"
                  label="On Hold"
                  data={OnHoldStatusData}
                />
                {/* </ConditionalField> */}
              </DisableForRoles>
            </HideForRoles>
          </FlexGridItem>

          <FlexGridItem xs={6}>
            <FlexTextField
              name="incidentAddress"
              label="Incident Address"
              required={true}
              validate={[required, maxLength50]}
              disabled={disableForm}
            />
          </FlexGridItem>

          <FlexGridItem xs={6}>
            <HideForRoles roles={[UserRoles.Partner, UserRoles.FMC, UserRoles.UNICEF]}>
              <DisableForRoles
                roles={[
                  UserRoles.UNICEF,
                  UserRoles.QMU,
                  UserRoles.Solution_Owner,
                  UserRoles.Solution_Team,
                ]}
                isnewcase={isNewCase}
                disableField={disableForm}
              >
                {/* <ConditionalField
                  field="caseType"
                  formName="mainForm"
                  condition={isClaim}
                > */}
                <FormSelect
                  name="claimStatus"
                  label="Claim Status"
                  data={claimStatus}
                />
                {/* </ConditionalField> */}
              </DisableForRoles>
            </HideForRoles>
          </FlexGridItem>

          <FlexGridItem xs={6}>
            <Grid container={true} spacing={2}>
              <FlexGridItem xs={4}>
                <FormLabel className="label-text">
                  GPS Coordinates :
                </FormLabel>
              </FlexGridItem>
              <FlexGridItem xs={4}>
                <FlexNumberField
                  name="gpsLatitude"
                  label="Latitude"
                  disabled={disableForm}
                  inputProps={{ min: 0 }}
                />
              </FlexGridItem>
              <FlexGridItem xs={4}>
                <FlexNumberField
                  name="gpsLongitude"
                  label="Longitude"
                  disabled={disableForm}
                  inputProps={{ min: 0 }}
                />
              </FlexGridItem>
            </Grid>
          </FlexGridItem >
          <FlexGridItem xs={6}>
            <HideForRoles roles={[UserRoles.Partner, UserRoles.FMC, UserRoles.UNICEF]}>
              <DisableForRoles
                roles={[
                  UserRoles.UNICEF,
                  UserRoles.QMU,
                  UserRoles.Solution_Owner,
                  UserRoles.Solution_Team,
                ]}
                isnewcase={isNewCase}
                disableField={disableForm}
              >
                {/* <ConditionalField
                  field="caseType"
                  formName="mainForm"
                  condition={isClaim}
                > */}
                <FormSelect
                  name="claimType"
                  label="Claim Type"
                  data={claimTypes}
                />
                {/* </ConditionalField> */}
              </DisableForRoles>
            </HideForRoles>
          </FlexGridItem >

          <FlexGridItem xs={6}>
            <DateField
              name="dateIssueNoticed"
              label="Date of incident"
              format={timestampToDate}
              normalize={dateToTimestamp}
              required={true}
              validate={[required, validDate]}
              disabled={disableForm}
            />
          </FlexGridItem >
          <FlexGridItem xs={6}></FlexGridItem>
          <FieldArray
            name="unicefOrderNos"
            component={UnicefOrderNoForm as any}
            props={{
              dispatch,
              disableForm,
              mainForm,
              isToasterVisible,
              openToaster,
            }}
          />
          <FlexGridItem xs={12}></FlexGridItem>
          <FlexGridItem xs={3}>
            <HideForRoles roles={[UserRoles.UNICEF]}>
              <ConditionalField
                field="caseType"
                formName="mainForm"
                condition={isClaim}
              >
                <EnableForRoles roles={[UserRoles.INS]}>
                  <FlexTextFieldNumber
                    name="insurancePolicyYear"
                    label="Insurance policy year (YYYY)"
                    validate={validYear}
                    disabled={disableForm}
                  />
                </EnableForRoles>
              </ConditionalField>
            </HideForRoles>
          </FlexGridItem>
          <FlexGridItem xs={12}>
            <TextArea
              name="descriptionOfTheIssue"
              label="Description of the issue"
              validate={required}
              required={true}
              disabled={disableForm}
            />
          </FlexGridItem>
          <FlexGridItem xs={12}>
            <label>Supplies delivered by a carrier? The carrier must be held liable when receiving damaged supplies </label>
          </FlexGridItem>
          <FieldArray
            name="supplyInfos"
            component={SupplyInfoForm as any}
            props={{
              dispatch,
              disableForm,
              mainForm,
              isToasterVisible,
              openToaster,
            }}
          />
          <FlexGridItem xs={12}>
            <Grid container={true} spacing={2}>
              <FlexGridItem xs={12}>
                <label>Info about the cargo such as product name, materials and order numbers</label>
              </FlexGridItem>
              <FlexGridItem xs={12}>
                <TextArea
                  name="otherSupplies"
                  label="Other Supplies"
                  validate={required}
                  required={true}
                  disabled={disableForm}
                />
              </FlexGridItem>
            </Grid>
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <FormSelect
              name="issueType"
              label="Issue Type"
              data={this.state.filteredIssueTypes}
              onChange={this.handleChangeIssueType}
              validate={required}
              required={true}
              disabled={disableForm}
            />
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <FormSelect
              name="category"
              label="Category"
              data={categoryList}
              validate={required}
              required={true}
              disabled={disableForm}
            />
          </FlexGridItem>
          <FlexGridItem xs={6}></FlexGridItem>
          <FlexGridItem xs={6}>
            <ConditionalField
              field="issueType"
              formName="mainForm"
              condition={isOneOf(IssueType.Shipment)}
            >
              <FormSelect
                name="inCaseOfShipment"
                label="In case of shipment"
                data={inCaseOfShipmentDataForIncident}
                validate={required}
                required={true}
                disabled={disableForm}
              />
            </ConditionalField>
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <ConditionalField
              field="issueType"
              formName="mainForm"
              condition={isOneOf(IssueType.Shipment)}
            >
              <h4>Transport / Shipment Information : </h4>
            </ConditionalField>
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <ConditionalField
              field="issueType"
              formName="mainForm"
              condition={isOneOf(IssueType.Inventory)}
            >
              <h4>Storage / Inventory Information : </h4>
            </ConditionalField>
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <ConditionalField
              field="issueType"
              formName="mainForm"
              condition={isOneOf(IssueType.Shipment)}
            >
              <FlexTextField
                name="transportMethod"
                label="Transport Method"
                disabled={disableForm}
              />
            </ConditionalField>
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <ConditionalField
              field="issueType"
              formName="mainForm"
              condition={isOneOf(IssueType.Inventory)}
            >
              <FlexTextField
                name="productName"
                label="Product Name"
                disabled={disableForm}
              />
            </ConditionalField>
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <ConditionalField
              field="issueType"
              formName="mainForm"
              condition={isOneOf(IssueType.Shipment)}
            >
              <FlexTextField
                name="nameOfCarrier"
                label="Name Of Carrier"
                disabled={disableForm}
              />
            </ConditionalField>
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <ConditionalField
              field="issueType"
              formName="mainForm"
              condition={isOneOf(IssueType.Inventory)}
            >
              <FlexTextField
                name="manufacturer"
                label="Manufacturer"
                disabled={disableForm}
              />
            </ConditionalField>
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <ConditionalField
              field="issueType"
              formName="mainForm"
              condition={isOneOf(IssueType.Shipment)}
            >
              <DateField
                name="departureDate"
                label="Departure Date"
                format={timestampToDate}
                normalize={dateToTimestamp}
                disabled={disableForm}
              />
            </ConditionalField>
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <ConditionalField
              field="issueType"
              formName="mainForm"
              condition={isOneOf(IssueType.Inventory)}
            >
              <DateField
                name="expiryDate"
                label="Expiry Date"
                format={timestampToDate}
                normalize={dateToTimestamp}
                disabled={disableForm}
              />
            </ConditionalField>
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <ConditionalField
              field="issueType"
              formName="mainForm"
              condition={isOneOf(IssueType.Shipment)}
            >
              <DateField
                name="expectedArrivalDate"
                label="Expected Arrival Date"
                format={timestampToDate}
                normalize={dateToTimestamp}
                disabled={disableForm}
              />
            </ConditionalField>
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <ConditionalField
              field="issueType"
              formName="mainForm"
              condition={isOneOf(IssueType.Inventory)}
            >
              <DateField
                name="dateReceived"
                label="Date Received"
                format={timestampToDate}
                normalize={dateToTimestamp}
                disabled={disableForm}
              />
            </ConditionalField>
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <ConditionalField
              field="issueType"
              formName="mainForm"
              condition={isOneOf(IssueType.Shipment)}
            >
              <FlexTextField
                name="transportUsdvalue"
                label="USD Value"
                disabled={disableForm}
              />
            </ConditionalField>
          </FlexGridItem>
          <FlexGridItem xs={6}>
            <ConditionalField
              field="issueType"
              formName="mainForm"
              condition={isOneOf(IssueType.Inventory)}
            >
              <FlexTextField
                name="productUsdvalue"
                label="USD Value"
                disabled={disableForm}
              />
            </ConditionalField>
          </FlexGridItem>
          <FlexGridItem xs={12}>
            <Grid container={true} spacing={2}>
              <h4>Objective Evidence : </h4>
              <FlexGridItem xs={12}>
                <label>Attach photos, notices filed against transport carriers/forwarders, reports, transport documents, invoices, packing list,
                  data from temperature monitoring devices, Vaccine Arrival Report (VAR). etc. (NB. Mandatory to ensure proper investigation)</label>
              </FlexGridItem>
              <FlexGridItem xs={12}>
                <AttachmentContainer
                  label="Attachments"
                  //uniqueId={uniqueId}
                  onSave={saveAttachmentData}
                  attachment={attachmentData}
                  download={downloadAttachment}
                  remove={deleteAttachment}
                  type={FORM_TYPE_MAIN}
                  disabled={disableForm}
                  {...this.props}
                />
              </FlexGridItem>
            </Grid>
          </FlexGridItem>
          <FlexGridItem xs={12}>
            <TextArea
              name="comments"
              label="Other Comments"
              disabled={disableForm} />
          </FlexGridItem>
        </Grid >
      </form >
    );
  }

  private disableForm = () => {
    const {
      caseData,
      currentRoleId,
      allowEdit,
      isNewCase,
      isLockForEdit,
      mainForm,
      currentUsername,
    } = this.props;
    let disableForm = false;
    if (!allowEdit) {
      disableForm = true;
    } else if (!isNewCase && caseData) {
      if (currentRoleId === UserRoles.UNICEF && isLockForEdit) {
        disableForm = true;
      } else if (
        currentRoleId === UserRoles.Solution_Owner ||
        currentRoleId === UserRoles.Solution_Team
      ) {
        // Get username who created the case
        let createdBy = mainForm.mainForm.values.createdBy;
        createdBy = getStringAfterSubstring(createdBy, "(");
        createdBy = getStringBeforeSubstring(createdBy, ")").trim();

        if (currentUsername !== createdBy || isLockForEdit) {
          disableForm = true;
        }
      }
    }

    return disableForm;
  };
}

function mapStateToProps(state: any) {
  setTimeout(() => { }, 100);
  return {
    countries: state.detail.countries,
    issueTypes: state.detail.issueTypes,
    claimStatus: state.detail.claimStatus,
    claimTypes: state.detail.claimTypes,
    mainForm: state.form,
    route: state.routing,
    attachmentData: state.detail.attachmentData,
    caseData: state.detail.caseData,
    allowEdit: state.detail.allowEdit,
    isLockForEdit: state.detail.isLockForEdit,
    countriesData: state.detail.countriesData,
    currentUser: state.home.currentUser,
    currentUsername: state.detail.currentUsername,
    isToasterVisible: state.common.isToasterVisible,
  };
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    saveAttachmentData: (
      file: any,
      uploadedBy: any,
      uniqueId: any,
      prevAttachmentData: any,
      type: string
    ) =>
      dispatch(
        actionSaveAttachmentData(
          file,
          uploadedBy,
          uniqueId,
          prevAttachmentData,
          type
        )
      ),
    downloadAttachment: (fileId: any) =>
      dispatch(actionDownloadAttachment(fileId)),
    deleteAttachment: (fileId: any, attachmentData: any, type: string) =>
      dispatch(actionDeleteAttachment(fileId, attachmentData, type)),
    openToaster: (message: string, success: boolean) =>
      dispatch(openToaster(message, success)),
    closeToaster: () => dispatch(closeToaster()),
  };
};


export default reduxForm({
  enableReinitialize: true,
  form: "mainForm",
  destroyOnUnmount: false,
  keepDirtyOnReinitialize: true,
  updateUnregisteredFields: true,
})(connect(mapStateToProps, mapDispatchToProps)(MainFormIncidentReportComponent));
//export default MainFormIncidentReportComponent;